document.addEventListener("turbolinks:load", function() {
    const content = document.querySelector('.post-content');
    const tocList = document.getElementById('toc-list');
    
    if (!content || !tocList) return;
  
    // 本文中のh2タグをすべて取得
    const headings = content.querySelectorAll('h2');
  
    headings.forEach((heading, index) => {
      // 1. 各見出しにIDを振る（飛び先にするため）
      const id = 'heading-' + index;
      heading.setAttribute('id', id);
  
      // 2. 目次用のリストアイテムを作成
      const li = document.createElement('li');
      const a = document.createElement('a');
      
      a.textContent = heading.textContent;
      a.href = '#' + id; // リンク先をIDに設定
      a.style.textDecoration = 'none';
      a.style.color = '#007bff';
  
      li.appendChild(a);
      li.style.marginBottom = '8px';
      tocList.appendChild(li);
    });
  });